import React from 'react';
import { Icon } from '@shoflo-rundown/polymer.legacy';
import { Dropdown, MenuItem } from 'bootstrap';
import classNames from 'classnames';

export default React.createClass({
  displayName: 'DropdownMenu',

  /**
   * Config Prop: {
   *    noCaret: React.PropTypes.bool,
   *    icon: React.PropTypes.string,
   *    content: React.PropTypes.string,
   *    items: [{
   *      id: itemId,
   *      type: "link"||"divider",
   *      content: String,
   *      onClick: Func
   *    }]
   *  }
   */
  propTypes: {
    dropup: React.PropTypes.bool,
    dropdownPrefix: React.PropTypes.string,
    config: React.PropTypes.object,
    classes: React.PropTypes.string,
  },

  getDefaultProps() {
    return {
      dropup: false,
    };
  },

  /**
   * TODO: Add support for adding active item and text
   */

  render() {
    const { dropup, classes, testId } = this.props;

    return (
      <Dropdown
        data-testid={testId}
        className={classNames(classes, { dropup: dropup === true })}
      >
        {this._getToggle()}
        <Dropdown.Menu>{this._getItems()}</Dropdown.Menu>
      </Dropdown>
    );
  },

  _getToggle() {
    const { config } = this.props;

    const icon = config.get('icon') ? (
      <Icon className="dropdown-icon" name={config.get('icon')} />
    ) : null;
    const iconRight = config.get('iconRight') ? (
      <Icon className="dropdown-icon" name={config.get('iconRight')} />
    ) : null;
    const content = config.get('content') ? (
      <span className="dropdown-content"> {config.get('content')}</span>
    ) : null;

    return (
      <Dropdown.Toggle noCaret={config.get('noCaret')}>
        {icon}
        {content}
        {iconRight}
      </Dropdown.Toggle>
    );
  },

  _getItems() {
    const itemMapper = {
      link: this._getLinkItem,
      divider: this._getDividerItem,
    };

    return this.props.config.get('items').map((item) => {
      const type = item.get('type') || 'link';
      return itemMapper[type](item);
    });
  },

  _getLinkItem(item) {
    const iconType = item.get('displayType');

    let iconName = null;

    if (iconType === 'list') {
      iconName = 'list';
    }
    if (iconType === 'schedule') {
      iconName = 'indent';
    }
    if (iconType === 'show') {
      iconName = 'table';
    }

    const itemClass = item.has('itemClass') ? item.get('itemClass') : '';

    const icon = iconType ? (
      <Icon className={'tab-shows-list-table-icons'} name={iconName} />
    ) : null;

    return (
      <MenuItem
        data-testid={this.props.itemTestId}
        onClick={item.get('onClick')}
        id={item.get('id')}
      >
        {icon}
        <span className={`menu-item-title ${itemClass}`}>
          {item.get('content')}
        </span>
      </MenuItem>
    );
  },

  _getDividerItem() {
    return <MenuItem divider />;
  },
});
